document.addEventListener("DOMContentLoaded", () => {
  const footer = document.getElementById("sticky-footer");
  if (!footer) return;

  const addBtn = footer.querySelector(".sf-add");
  const buyBtn = footer.querySelector(".sf-buy");
  const priceSpan = footer.querySelector(".sf-price");

  // Price load
  const priceNode = document.querySelector("[data-product-price]") ||
                    document.querySelector(".price-item--regular") ||
                    document.querySelector(".price") ||
                    null;

  if (priceNode) priceSpan.textContent = priceNode.textContent.trim();

  const productForm =
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector("product-form") ||
    document.querySelector("form");

  if (!productForm) {
    footer.style.display = "none";
    return;
  }

  // Add to Cart
  addBtn.addEventListener("click", async () => {
    const fd = new FormData(productForm);
    await fetch("/cart/add.js", { method: "POST", body: fd });
    addBtn.textContent = "Added!";
    setTimeout(() => (addBtn.textContent = "Add to cart"), 1500);
  });

  // Buy Now
  buyBtn.addEventListener("click", async () => {
    const fd = new FormData(productForm);
    await fetch("/cart/add.js", { method: "POST", body: fd });
    window.location.href = "/cart";
  });
});
